"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var SkeletonGroup_1 = __importDefault(require("atomicComponents/atoms/Skeleton/SkeletonGroup"));
var Tooltip_1 = __importDefault(require("atomicComponents/atoms/Tooltip"));
var ProfileAvatar_1 = __importDefault(require("atomicComponents/molecules/Image/ProfileAvatar"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var single_1 = require("utils/selectors/single");
var WizardParts_1 = require("../../WelcomeFlow/WizardParts");
var PREFIX = 'TeamsHeader';
var classes = {
    placeholder: "".concat(PREFIX, "-placeholder"),
    spend: "".concat(PREFIX, "-spend"),
    flatRightRadius: "".concat(PREFIX, "-flatRightRadius"),
    popup: "".concat(PREFIX, "-popup"),
};
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.placeholder)] = {
            borderRadius: 12,
            backgroundColor: theme.palette.grey[500],
        },
        _b[".".concat(classes.spend)] = {
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.grey[700],
            height: 12,
            display: 'flex',
            alignItems: 'center',
        },
        _b[".".concat(classes.flatRightRadius)] = {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
        },
        _b["&.".concat(classes.popup)] = {
            '& p': {
                color: theme.palette.common.white,
            },
        },
        _b);
});
var TeamsHeader = function () {
    var currentStep = react_1.default.useContext(WizardParts_1.WizardContext).currentStep;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _a = (0, react_final_form_1.useFormState)({ subscription: { active: true, values: true } }), active = _a.active, formValues = _a.values;
    var userTeamRel = formValues.userTeamRel, team = formValues.team, profileValues = formValues.profile;
    var _b = profileValues || {}, firstName = _b.firstName, lastName = _b.lastName;
    var teamName = team === null || team === void 0 ? void 0 : team.name;
    var popupOpen = ((firstName || lastName) && currentStep === 'USER_INTRO')
        || (active === 'userTeamRel.position');
    var popupTitle = popupOpen && ((0, jsx_runtime_1.jsxs)(StyledBox, __assign({ px: 4, py: 2, display: "flex", flexDirection: "column", alignItems: "center", className: classes.popup }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (0, jsx_runtime_1.jsx)("b", { children: [firstName, lastName].filter(Boolean).join(' ') || profile.displayName }) })), (userTeamRel === null || userTeamRel === void 0 ? void 0 : userTeamRel.position) && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: userTeamRel === null || userTeamRel === void 0 ? void 0 : userTeamRel.position })) }))] })));
    return ((0, jsx_runtime_1.jsxs)(StyledBox, __assign({ py: 3, display: "flex", justifyContent: "space-between", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ width: 135, minWidth: 135 }, { children: teamName
                    ? (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2, noWrap: true }, { children: teamName }))
                    : (0, jsx_runtime_1.jsx)(material_1.Box, { width: 130, height: 12, className: classes.placeholder }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ placement: "bottom", color: "primary", variant: "dark", open: popupOpen, title: popupTitle, arrow: true }, { children: (0, jsx_runtime_1.jsx)("span", { children: profile && (0, jsx_runtime_1.jsx)(ProfileAvatar_1.default, { profile: profile }) }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ ml: 1 }, { children: (0, jsx_runtime_1.jsx)(SkeletonGroup_1.default, { children: __spreadArray([], __read(Array(5).keys()), false).map(function (el) { return ((0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "circular", width: 24, height: 24 }, el)); }) }) }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mr: 1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { width: 128, height: 12, className: classes.placeholder }) }))] })));
};
exports.default = TeamsHeader;
